module.exports = __webpack_public_path__ + "img/BW.4b89d1bb.png";